import React from 'react';
import ASSETS from '../../assets';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div
      id='footer'
      className='bg-l-light-grey md:rounded-[24px] rounded-[12px] lg:px-[68px] md:px-12 px-5 lg:py-12 md:py-6 py-5 mt-auto'
    >
      <img src={ASSETS.logo} className='h-10' alt='' />
      <p className='text-base font-medium max-w-[40ch] text-l-primary mt-10'>
        Simplifying legal advice with expert guidance at your fingertips.
      </p>
      <div className='sm:mt-5 mt-5'>
        <div className='flex items-center gap-4'>
          <div className='w-6'>
            <img src={ASSETS.call} alt='' />
          </div>
          <p className='text-lg font-semibold text-l-primary'>03295134749</p>
        </div>
      </div>
      <div className='flex items-center justify-between flex-wrap '>
        <div className='flex items-center gap-4'>
          <div className='w-6'>
            <img src={ASSETS.mail} alt='' />
          </div>
          <p className='text-lg font-semibold text-l-primary'>
            info@legalavenue.pk
          </p>
        </div>
        <div className='flex items-center flex-wrap gap-4 mt-4'>
          <a
            href='https://apps.apple.com/us/app/legal-avenue/id6474690584'
            target='_blank'
            rel='noreferrer'
          >
            <div className='w-[200px] bg-white rounded-md p-3 flex items-center gap-3'>
              <img src={ASSETS.appStore} alt='' />
              <div>
                <p className='text-sm text-l-primary'>Download on the</p>
                <p className='text-base font-semibold text-l-primary leading-5'>
                  App Store
                </p>
              </div>
            </div>
          </a>
          <a
            href='https://play.google.com/store/apps/details?id=com.techconsultivo.legalavenue'
            target='_blank'
            rel='noreferrer'
          >
            <div className='w-[200px] bg-white rounded-md p-3 flex items-center gap-3'>
              <img src={ASSETS.playStore} alt='' />
              <div>
                <p className='text-sm text-l-primary'>Get in on</p>
                <p className='text-base font-semibold text-l-primary leading-5'>
                  Play Store
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className='bg-l-primary flex flex-wrap items-center justify-between  mt-12 lg:px-12 md:px-6 px-4 md:rounded-[24px] rounded-[12px] py-5 gap-4'>
        <div className='flex items-center md:gap-6 gap-3'>
          <a
            href='http://instagram.com/legalavenuepk'
            rel='noreferrer'
            target='_blank'
          >
            <img src={ASSETS.instagram} alt='' />
          </a>
          <a
            href='https://web.facebook.com/LegalAavenuePK'
            rel='noreferrer'
            target='_blank'
          >
            <img src={ASSETS.facebook} alt='' />
          </a>
          <a
            href='https://x.com/legalavenuepk'
            rel='noreferrer'
            target='_blank'
          >
            <img src={ASSETS.twitter} alt='' />
          </a>
          <a
            href='https://www.linkedin.com/company/legalavenuepk'
            rel='noreferrer'
            target='_blank'
          >
            <img src={ASSETS.linkedIn} width={30} alt='' />
          </a>
        </div>
        <div className='flex items-center lg:gap-10 md:gap-5 gap-3'>
          <Link to='/privacy-policy'>
            <p className='text-white font-semibold lg:text-lg text-base'>
              Privacy Policy
            </p>
          </Link>
          <Link to='/terms-of-use'>
            <p className='text-white font-semibold lg:text-lg text-base'>
              Terms of Use
            </p>
          </Link>
        </div>
        <p className='text-white md:text-base text-sm'>© 2024 Legal Avenue</p>
      </div>
    </div>
  );
};

export default Footer;
